import React from 'react';

import { useSearchState } from './use-search-state';

type ChartSearchContextProviderProps = {
  namespace: string;
  children: React.ReactNode;
};

const ChartSearchContext = React.createContext<ReturnType<typeof useSearchState> | undefined>(
  undefined,
);

ChartSearchContext.displayName = 'ChartSearchContext';

export function ChartSearchContextProvider({
  namespace,
  children,
}: ChartSearchContextProviderProps): React.ReactElement {
  const value = useSearchState(namespace);

  return <ChartSearchContext.Provider value={value}>{children}</ChartSearchContext.Provider>;
}

export function useChartSearchContext(): ReturnType<typeof useSearchState> {
  const context = React.useContext(ChartSearchContext);

  if (!context) {
    throw new Error('useChartSearchContext must be used within ChartSearchContextProvider');
  }

  return context;
}
